/*** IMPORTS FROM imports-loader ***/
var define = false;

// empty.js
export default () => {};


